export const storageName = "BaDataUser";
export const lsToken = "BaToken";
export const lsSelectedCompany = "BaCompanySelected";
export const lsTheme = "BaTheme";